var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.25c-4.168 0-7.499 3.499-7.499 7.755v.705a3.65 3.65 0 0 1-.574 1.971l-1.107 1.724c-1.269 1.976-.322 4.698 1.947 5.34.669.189 1.343.352 2.021.488.003.01.007.021.011.031.769 2.052 2.824 3.487 5.202 3.487s4.433-1.435 5.202-3.487c.004-.01.007-.021.011-.031a26.7 26.7 0 0 0 2.021-.488c2.269-.642 3.216-3.364 1.947-5.34l-1.107-1.724a3.65 3.65 0 0 1-.574-1.971v-.705c0-4.256-3.331-7.755-7.499-7.755zm3.379 18.284c-2.244.288-4.514.288-6.757 0C9.332 20.557 10.57 21.25 12 21.25s2.668-.693 3.379-1.716zM6.001 9.005C6.001 5.524 8.713 2.75 12 2.75s5.999 2.774 5.999 6.255v.705a5.15 5.15 0 0 0 .812 2.781l1.108 1.724c.754 1.174.156 2.733-1.093 3.086-4.469 1.265-9.182 1.265-13.651 0-1.249-.354-1.847-1.913-1.093-3.086l1.107-1.724a5.15 5.15 0 0 0 .812-2.781v-.705z",
    fill: "#888b8d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/News.46991775aaf433d02951f527cfe9661a.svg";
export { ForwardRef as ReactComponent };